module.exports = __webpack_public_path__ + "static/Pages-c8ec203c6824b6d7b35b94c022822f91.png";